<div class="container" (keydown)="keyDownFunction($event)">
    <div class="row">
        <div class="col-24">
            <h1 class="medium">Enrollment Acknowledgement- Step 5</h1>
        </div>
    </div>
    <div class="row">
        <div class="col-16">
            <p class="blue-text"> <b>Selected Plan</b> : {{planName}} </p>
            <!--<p class="blue-text"> <b>Group Number </b> : {{planName}} </p>-->
        </div>
    </div>
    <div class="row">
        <div class="col-16">
            <p class="qtip-note bottom-20">(<strong>Note to Agent:</strong> The Agent MUST Read This Important Information.)</p>
            <p class="qtip-note bottom-20">(<strong>Note to Agent:</strong> Medicare requires a clear "Yes" or "No" response to each of the following statements.)</p>
        </div>
    </div>
    <div class="row">
        <div class="col-16">
            <div class="blue-neje-text bottom-20">
                <p class="bottom-20">
                    By completing this telephone enrollment, you (or your authorized representative) acknowledge and agree to the following:
                </p>

                <div>
                    Blue MedicareRx is a Medicare drug plan and has a contract with the Federal government. You understand that this prescription drug coverage is in addition to your coverage under Medicare; therefore, you will need to keep your Medicare Part A or Part B coverage. It is your responsibility to inform Blue MedicareRx of any prescription drug coverage that you have or may get in the future. You can only be in one Medicare prescription drug plan at a time - if you are currently in a Medicare Prescription Drug Plan, your enrollment in Blue MedicareRx will end that enrollment.
                    <br />
                </div>

                <div class="row">
                    <div class="col-16">
                        <fieldset class="radio">
                            <ValidatedRadioButtonGroup [options]="rblAgreement"
                                                       [radioGroupName]="'y1'"
                                                       (onValueChange)="SelectYesNoChange($event,'y1')"
                                                       [selectedValue]="enrollmentViewModel.y1">
                            </ValidatedRadioButtonGroup>
                        </fieldset>
                    </div>
                 </div>
                <div class="row">

                    Enrollment in this plan is generally for the entire year. Once you enroll, you may leave this plan or make changes if an enrollment period is available, generally during the Annual Enrollment Period (October 15th - December 7th), unless you qualify for certain special circumstances.<br />
                    <div class="col-16">
                        <fieldset class="radio">
                            <ValidatedRadioButtonGroup [options]="rblAgreement"
                                                       [radioGroupName]="'y2'"
                                                       (onValueChange)="SelectYesNoChange($event,'y2')"
                                                       [selectedValue]="enrollmentViewModel.y2">
                            </ValidatedRadioButtonGroup>
                        </fieldset>
                    </div>
                </div>  


                <div class="row">
                    
                    <div *ngIf="!Script2023; else Context_2023">
                        Blue MedicareRx serves a specific service area. If you move out of the area that Blue MedicareRx serves, you need to notify the plan so you can disenroll and find a new plan in your new area. You understand that you must use network pharmacies except in an emergency when you cannot reasonably use Blue MedicareRx network pharmacies. Once you are a member of Blue MedicareRx, you have the right to appeal plan decisions about payment or services if you disagree. You will read the Evidence of Coverage document from Blue MedicareRx when you get it to know which rules you must follow to get coverage.
                    </div>
                    <ng-template #Context_2023>
                        Blue MedicareRx serves a specific service area. If you move out of the area that Blue MedicareRx serves, you need to notify the plan so you can disenroll and find a new plan in your new area. You understand that you must use network pharmacies except in an emergency when you cannot reasonably use Blue MedicareRx network pharmacies. Once you are a member of Blue MedicareRx, you have the right to appeal plan decisions about payment or services if you disagree. You will read the Evidence of Coverage document from Blue MedicareRx when you get it to know which rules you must follow to get coverage.                        You can view the Evidence of Coverage, Summary of Benefits, and Stars Rating Sheet online at rxmedicareplans.com or you can request a hardcopy to be mailed to you.
                    </ng-template>
                    <br />
                    <div class="col-16">
                        <fieldset class="radio">
                            <ValidatedRadioButtonGroup [options]="rblAgreement"
                                                       [radioGroupName]="'y3'"
                                                       (onValueChange)="SelectYesNoChange($event,'y3')"
                                                       [selectedValue]="enrollmentViewModel.y3">
                            </ValidatedRadioButtonGroup>
                        </fieldset>
                    </div>
                </div>  
                <div class="row">
                    You understand that if you leave this plan and don't have or get other Medicare prescription drug coverage or creditable prescription drug coverage (as good as Medicare's), you may have to pay a late enrollment penalty in addition to your premium for Medicare prescription drug coverage in the future.<br />
                    <div class="col-16">
                        <fieldset class="radio">
                            <ValidatedRadioButtonGroup [options]="rblAgreement"
                                                       [radioGroupName]="'y4'"
                                                       (onValueChange)="SelectYesNoChange($event,'y4')"
                                                       [selectedValue]="enrollmentViewModel.y4">
                            </ValidatedRadioButtonGroup>
                        </fieldset>
                    </div>
                </div>
                <div class="row">
                    You understand that if you are getting assistance from a sales agent, broker, or other individual employed by or contracted with Blue MedicareRx, he/she may be paid based on your enrollment in Blue MedicareRx.<br />
                    <div class="col-16">
                        <fieldset class="radio">
                            <ValidatedRadioButtonGroup [options]="rblAgreement"
                                                       [radioGroupName]="'y5'"
                                                       (onValueChange)="SelectYesNoChange($event,'y5')"
                                                       [selectedValue]="enrollmentViewModel.y5">
                            </ValidatedRadioButtonGroup>
                        </fieldset>
                    </div>
                </div>
                <div class="row">
                    Counseling services may be available in your state to provide advice concerning Medicare supplement insurance or other Medicare Advantage or Prescription Drug Plan options, medical assistance through the state Medicaid program, and the Medicare Savings Program.
                    <br /><br />
                    <p><strong>Release of Information:</strong> By joining this Medicare prescription drug plan, you acknowledge that Blue MedicareRx will release your information to Medicare and other plans as is necessary for treatment, payment and health care operations. You also acknowledge that Blue MedicareRx will release your information, including your prescription drug event data, to Medicare, who may release it for research and other purposes which follow all applicable Federal statutes and regulations. The information on this enrollment is correct to the best of your knowledge. You understand that if you intentionally provide false information, you will be disenrolled from the plan.</p>                    
                    <div class="col-16">
                        <fieldset class="radio">
                            <ValidatedRadioButtonGroup [options]="rblAgreement"
                                                       [radioGroupName]="'y6'"
                                                       (onValueChange)="SelectYesNoChange($event,'y6')"
                                                       [selectedValue]="enrollmentViewModel.y6">
                            </ValidatedRadioButtonGroup>
                        </fieldset>
                    </div>
                </div>
                <div class="row">
                    You understand that your verbal agreement (or the verbal agreement of the person authorized to act on your behalf under State law where you live) on this application means that you (or your authorized representative) have heard and understand the contents of this application. If agreed to by an authorized individual (as described above), you certify that: 1) you are authorized under State law to complete this enrollment and 2) documentation of this authority is available upon request by Blue MedicareRx or by Medicare.
                    <br />
                    <div class="col-16">
                        <fieldset class="radio">
                            <ValidatedRadioButtonGroup [options]="rblAgreement"
                                                       [radioGroupName]="'y7'"
                                                       (onValueChange)="SelectYesNoChange($event,'y7')"
                                                       [selectedValue]="enrollmentViewModel.y7">
                            </ValidatedRadioButtonGroup>
                        </fieldset>
                    </div>
                </div>

                <div class="row">
                    <strong>Do you wish to proceed with submitting this application to Medicare? </strong>   <div class="col-16">
                        <fieldset class="radio">
                            <ValidatedRadioButtonGroup [options]="rblAgreement"
                                                       [radioGroupName]="'y8'"
                                                       (onValueChange)="SelectYesNoChange($event,'y8')"
                                                       [selectedValue]="enrollmentViewModel.y8">
                            </ValidatedRadioButtonGroup>
                        </fieldset>
                    </div>
                </div>
                <div class="row">
                    <p class="qtip-note bottom-20"><strong>If Yes:</strong> Continue</p>
                    <p class="qtip-note bottom-20">
                        <strong>
                            If NO:
                        </strong> Okay, Mr./Mrs. {{BenefName}}, since you have stated that you do not want me to submit your application to Medicare,<br />
                            I will not need to capture any additional information.Thank you for your time. Is there anything else I can help you with today?                       
                    </p>
                 </div>
                <div class="row">
                    <div class="col-24">
                        <h1 class="medium">Phone Enrollment Close- Step 6</h1>
                    </div>
                </div>
                <p>
                    Thank you for providing that information Mr./Mrs. {{BenefName}} Your phone enrollment in the
                    <br /><br />
                    <strong>IF IEP or SEP enrollment period:</strong>
                    Blue MedicareRx Plan is now complete. Pending Medicare approval, your coverage will begin on {{effectiveDate}}. (<strong>Note to Agent:</strong> Effective date: first of the following month of application). You will receive an application status letter within 10 calendar days.
                    <br /><br />
                    <strong>IF AEP enrollment period (October 15th - December 7th)</strong>
                    Blue MedicareRx Plan is now complete. Pending Medicare approval, your coverage will begin on on January 1, {{enrollmentViewModel.PLANYEAR}}. You will receive an application status letter within 10 calendar days.
                </p>

                    <p>
                        <u><strong>Enrollment Verification:</strong></u><br />
                        Mr./Mrs. <strong>{{BenefName}} </strong> I would also like to advise you that you will be receiving a letter in the mail confirming your enrollment into the Blue MedicareRx Plan. The purpose of this letter is to ensure you understand the rules of the plan, before your enrollment into the plan becomes final.<br /><br />
    Upon approval of your application from Medicare, Blue MedicareRx will mail you a plan welcome kit. Included in your kit will be your member ID card. This card will contain all the necessary information your pharmacist needs to fill your prescriptions. You will also need information from this card to request a prescription fill from the mail service pharmacy.<br /><br />
    Is there anything else I can help you with today? For additional information regarding your Blue MedicareRx plan you can go to <a class="link" href="http://www.RxMedicarePlans.com" target="_blank">www.RxMedicarePlans.com</a> or call Customer Care at:
</p>                
                <div class="row">
                    <div class="col-4">

                    </div>
                    <div class="col-4">
                        <b> BCBS of CT:</b> 
                    </div>
                    <div class="col-4">
                        <b>1-888-620-1747</b> 
                    </div>
                    <div class="col-4">
                        <b>   TTY/TDD: 711</b> 
                    </div>
                </div>
                <div class="row">
                    <div class="col-4">

                    </div>
                    <div class="col-4">
                        <b>  BCBS of MA:</b>  
                    </div>
                    <div class="col-4">
                        <b>1-888-543-4917</b> 
                    </div>
                    <div class="col-4">
                        <b>  TTY/TDD: 711 </b> 
                    </div>
                </div>
                <div class="row">
                    <div class="col-4">

                    </div>
                    <div class="col-4">
                        <b>   BCBS of RI:</b> 
                    </div>
                    <div class="col-4">
                        <b>1-888-620-1748</b> 
                    </div>
                    <div class="col-4">
                        <b>  TTY/TDD: 711 </b> 
                    </div>
                </div>

                <div class="row">
                    <div class="col-4">

                    </div>
                    <div class="col-4">
                        <b>   BCBS of VT: </b> 
                    </div>
                    <div class="col-4">
                        <b>1-888-620-1746</b> 
                    </div>
                    <div class="col-4">
                        <b>    TTY/TDD: 711 </b> 
                    </div>
                </div>  
                <div class="row"></div>
                </div>
        </div>
    </div>


    <div class="row">
        <div class="col-24" *ngIf="showContinue">
            <button class="button primary"  (click)="formSubmit()">The Applicant has read and agrees to the Terms of Enrollment</button>            
        </div>
        <div class="col-24" *ngIf="!showContinue">
            <p class="qtip-note bottom-20"><strong>Please select Yes to above questions to proceed with application.</strong></p>
        </div>
    </div>
    <div class="row">
        <div class="col-24">
            <button class="button cancel" (click)="onBack()">Go Back and Make Changes</button>
        </div>
    </div>
